/**
 * Firebase creative document IDs referenced from a campaign document.
 */

export const getCampaignCreativeIds = (campaign) => {
  if (!campaign?.creativeDetails || typeof campaign.creativeDetails !== 'object') return [];
  const ids = [];
  Object.values(campaign.creativeDetails).forEach((detail) => {
    if (!Array.isArray(detail?.creatives)) return;
    detail.creatives.forEach((creative) => {
      if (creative?.id) ids.push(creative.id);
    });
  });
  return Array.from(new Set(ids));
};

const pushCreativeIdFromEntry = (ids, entry) => {
  if (entry == null) return;
  if (typeof entry === 'string') {
    const s = entry.trim();
    if (s) ids.push(s);
    return;
  }
  if (typeof entry === 'object') {
    const id = String(entry.id || entry.creativeId || '').trim();
    if (id) ids.push(id);
  }
};

/** Creative ids from per-sign assignedCreatives map (arrays of objects or string ids). */
export const getAssignedCreativeIdsFromCampaign = (campaign) => {
  const ac = campaign?.assignedCreatives;
  if (!ac || typeof ac !== 'object') return [];
  const ids = [];
  for (const val of Object.values(ac)) {
    if (!Array.isArray(val)) continue;
    val.forEach((e) => pushCreativeIdFromEntry(ids, e));
  }
  return Array.from(new Set(ids));
};

export const getAllFirebaseCreativeIdsForCampaign = (campaign) =>
  Array.from(new Set([...getCampaignCreativeIds(campaign), ...getAssignedCreativeIdsFromCampaign(campaign)]));
